import React from 'react'

const AboutSection = () => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container-padding text-center">
        <h2 className="text-2xl font-semibold mb-4">About FlowBeatIQ</h2>
        <p className="max-w-3xl mx-auto text-gray-600 text-lg leading-relaxed">
          FlowBeatIQ helps local businesses understand and improve customer flow using
          privacy-safe Wi-Fi analytics. Built by engineers who believe small shops deserve
          the same insights big retailers use — without cameras, complexity, or enterprise costs.
        </p>
      </div>
    </section>
  )
}

export default AboutSection
